import React from 'react';
import { Table, TableColumn } from 'common/components/Table';
import DropdownMenu from '../DropdownMenu';
import { Workflow } from 'pages/AgenticWorkflow/AgenticWorkflow.types';
import styles from './WorkflowsTable.module.scss';

interface WorkflowsTableProps {
    workflows: Workflow[];
    loading: boolean;
    onRowClick: (workflow: Workflow) => void;
    onDeleteSuccess: () => void;
    onUploadClick: (workflow: Workflow) => void;
}

const WorkflowsTable: React.FC<WorkflowsTableProps> = ({
    workflows,
    loading,
    onRowClick,
    onDeleteSuccess,
    onUploadClick,
}) => {
    // Format date to display in a readable format
    const formatDate = (dateString?: string): string => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleDateString();
    };

    const columns: TableColumn<Workflow>[] = [
        {
            key: 'title',
            title: 'Name',
            dataIndex: 'title',
        },
        {
            key: 'description',
            title: 'Description',
            dataIndex: 'description',
        },
        {
            key: 'status',
            title: 'Status',
            render: (_, record) => (
                <span className={`${styles.status} ${styles[record.status?.toLowerCase() as keyof typeof styles]}`}>
                    {record.status || 'Active'}
                </span>
            ),
        },
        {
            key: 'total_calls',
            title: 'Total Calls',
            render: (_, record) => record.total_calls || 0,
        },
        {
            key: 'pending_calls',
            title: 'Pending Calls',
            render: (_, record) => record.pending_calls || 0,
        },
        {
            key: 'start_date',
            title: 'Start Date',
            render: (_, record) => formatDate(record.start_date),
        },
        {
            key: 'end_date',
            title: 'End Date',
            render: (_, record) => formatDate(record.end_date),
        },
        {
            key: 'created_at',
            title: 'Creation Date',
            render: (_, record) => formatDate(record.created_at || new Date().toISOString()),
        },
        {
            key: 'actions',
            title: 'Actions',
            render: (_, record) => (
                <div onClick={(e) => e.stopPropagation()}>
                    <DropdownMenu workflow={record} onDeleteSuccess={onDeleteSuccess} onUploadClick={onUploadClick} />
                </div>
            ),
        },
    ];

    return (
        <div className={styles.tableContainer}>
            <Table
                data={workflows}
                columns={columns}
                isLoading={loading}
                rowKey='id'
                onRowClick={(workflow) => onRowClick(workflow)}
                hoverable
                variant='primary'
                emptyText='No workflows found'
            />
        </div>
    );
};

export default WorkflowsTable;
